import { MODEL_LABELS, isModelId, normalizeModel } from '@term-deck/core/model.js';
import { CODEX_MODEL_LABELS, isCodexModelId } from '@term-deck/core/codex-model.js';

/**
 * AL.F1 (PB.2, 20/09/2026) — nomes legíveis com FONTE ÚNICA no core: `MODEL_LABELS` (Claude) e
 * `CODEX_MODEL_LABELS` (Codex) são os mesmos que REST/MCP usam. Um modelo novo entra numa linha do core e aparece
 * aqui sem editar lista. O que o core não conhece (id do catálogo ACP recém-observado) cai no FALLBACK: o rótulo
 * do catálogo quando o chamador o passa, senão o id cru — nunca "modelo desconhecido" disfarçado de nome.
 */
const CLAUDE_ALIAS_LABEL: Record<string, string> = { default: 'Padrão do provedor' };

export function modelDisplayName(model: string | null | undefined, catalogLabel?: string | null): string {
  if (!model) return 'modelo ainda não observado';
  if (model in CLAUDE_ALIAS_LABEL) return CLAUDE_ALIAS_LABEL[model]!;
  const bare = model.replace(/\[1m\]$/, '');
  if (isModelId(bare)) return MODEL_LABELS[bare];
  const normalized = normalizeModel(bare);
  if (normalized) return MODEL_LABELS[normalized];
  if (isCodexModelId(bare)) return CODEX_MODEL_LABELS[bare];
  if (bare === 'gpt-6-astra') return 'GPT-6 Astra';
  return catalogLabel?.trim() || model;
}
export function providerDisplayName(provider: string | null | undefined): string {
  const value = provider?.replace(/^acp:/, '') ?? '';
  return value === 'codex' ? 'Codex' : value === 'claude' ? 'Claude' : value === 'glm' ? 'GLM' : value || 'provedor ainda não observado';
}
export function effortDisplayName(effort: string | null | undefined): string {
  return ({ low: 'baixo', medium: 'médio', high: 'alto', xhigh: 'muito alto', max: 'máximo', ultra: 'ultra', default: 'padrão' } as Record<string, string>)[effort ?? ''] ?? (effort || 'esforço ainda não observado');
}
